"use client";

import * as React from "react";
import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

export type SuggestionsProps = ComponentProps<"div">;

export const Suggestions = ({
	className,
	children,
	...props
}: SuggestionsProps) => (
	<div
		className={cn(
			"flex flex-wrap items-center justify-center gap-2",
			className,
		)}
		{...props}
	>
		{children}
	</div>
);

export type SuggestionProps = Omit<ComponentProps<typeof Button>, "onClick"> & {
	/** The text handed back on click, which need not be what the pill reads. */
	suggestion: string;
	onClick?: (suggestion: string) => void;
};

export const Suggestion = ({
	suggestion,
	onClick,
	className,
	variant = "outline",
	size = "sm",
	children,
	...props
}: SuggestionProps) => (
	<Button
		className={cn("cursor-pointer rounded-full px-4", className)}
		onClick={() => onClick?.(suggestion)}
		size={size}
		type="button"
		variant={variant}
		{...props}
	>
		{children || suggestion}
	</Button>
);
